<template>
<div class="home">
  <!-- swper -->
<div class="back">
  <div class="wswiper">
   <div class="swper_box" @mouseenter="enter" @mouseleave="leave" >
     <swiper :options="swiperOptions" ref="mySwiper">
        <swiper-slide v-for="(item,index) in swiperlist"  :key="index" >
           <img :src="item.img" alt="">

           <!-- <div class="swiper_mouser">
             <img src="../assets/image/mouser.png" alt="">
           </div> -->
        </swiper-slide>

         <div class="swiper-pagination" slot="pagination" @click="fn"></div>
         <div class="swiper-button-prev" slot="button-prev"></div>
         <div class="swiper-button-next" slot="button-next"></div>

     </swiper>

     <!-- 轮播图中的文字 -->
  <Nav></Nav>
   </div>

  </div>

   <transition name="my">
     <div class="fixed" v-show="fiehow"  >
    <ul>
      <li v-for="(item,index) in fixedlist" ref="mou" @mouseenter="mousert(item)" @mouseleave="mouleave(item)" @click="fixed(item)" :class="{'fixd':currsId===item.id}" :key="index">
      <img :src="item.img" alt="">
      </li>

    </ul>

  </div>

   </transition>
  <div class="daylog">
       <el-dialog title="" :visible.sync="dialogFormVisible">
  <el-form :model="form">
    <el-form-item  :label-width="formLabelWidth">

   <el-input v-model="form.input" placeholder="请输入您的姓名"></el-input>
   <el-input v-model="form.input1" placeholder="请输入您的电话"></el-input>
   <el-input v-model="form.input2" placeholder="其他联系方式（微信/邮箱等）"></el-input>
    <el-input
    class="textar"
  type="textarea"
  :rows="2"
  placeholder="输入您的合作诉求..."
  v-model="form.textarea">
</el-input>
    </el-form-item>

  </el-form>
  <div slot="footer" class="dialog-footer">

    <el-button type="primary" @click="submit">确 定</el-button>
  </div>
     </el-dialog>
  </div>
  <div class="w mains">
    <main>
      <div class="cus"></div>
      <div class="main_header">
      <transition>
        <img src="../assets/img/guanyu.png" ref="mainshe" alt="">
          <!-- <a href="javascript:;" >关于我们</a> -->
      </transition>
      </div>

      <div class="main">Hundred平台是一家开发动漫运营社区的广告传媒公司；隶属于上海致源广告传媒有限公司，随着网络游戏的迅速发展， 中国网络游戏市场规模逐渐扩大， 游戏收入有望超越美国排名全球第一。
单一媒体已无法满足游戏大市场的需求， 因而产生了如今的Hundred广告投放平台；
平台结合了如今市场上游戏投放主流媒体的资源以及我们慢慢挖掘的初步商业化媒体的资源融入平台的SSP， 长期累积下来的DMP数据包更能帮助广告主达到理想效果.团队来自各大游戏厂商以及渠道代理优秀优化人员， 公司原有漫画设计人员能更好地提供素材设计思路以及修改原有素材。 我们拥有专业的技术团队，拥有广阔的媒体资源，拥有资深的优化师。Hundred希望给手游带来独特的价值， 移动互联网将因广告而更精彩！
</div>
      <div class="main_footer">
        <ul>
          <li v-for="(item,index) in reagrs" :key="index">
            <img v-lazy="item.img" alt="">
            <span>{{item.name}}</span>
            <p>{{item.desc}}</p>
          </li>

        </ul>
      </div>

    </main>
  </div>
  <div class="mased" >
    <div class="w">
   <div class="juqerbar">
        <div class="main_jquers_header">
          <img src="../assets/img/pintai.png"  ref="mdidest" alt="">
        <!-- <a href="">  平台优势</a> -->
      </div>
      <div class="Plat">
        <!-- Platform Advantages -->
      </div>
      <div class="number">
      <ul>
        <li>
          <img src="../assets/image/one.png" alt="">
        </li>
         <li>
          <img src="../assets/image/two.png" alt="">
        </li>
         <li>
          <img src="../assets/image/three.png" alt="">
        </li>
         <li>
          <img src="../assets/image/four.png" alt="">
        </li>

      </ul>

      </div>
      <div class="main_jquers_main">
          <ul>
            <li v-for="(item,index) in requers" :class="{'mainst':item.id===crrId}" @mousemove="mainjquers(item)" :key="index">

            <div class="post">
                <img :src="item.img" alt="">
            </div>
              <p>{{item.name}}</p>
              <span>{{item.desc}}</span>
            </li>

          </ul>
      </div>

   </div>
  </div>
  </div>
<div class="alge">
    <div class="w">
     <section >
       <div class="maretbar"></div>
       <div class="panter">
        <!-- <a href="javascript:;" >合作案例</a> -->
        <img ref="hovsert" src="../assets/img/anli.png" alt="">
       </div>
      <div class="ss"   @mouseenter="enters" @mouseleave="leavese" >
          <swiper :options="swiperOptions1"  ref="swipe" >
            <swiper-slide v-for="(item,index) in swiperlabel" :key="index">
                <div class="swper_main">
             <img :src="item.img" alt="">

          <div class="swper_right">
            <ul>
              <li v-for="(item,index) in desclist" :key="index">
                 <div class="desc">
              {{item.name}}
             </div>
             <p class="swiping">{{item.desc}}</p>
             <p class="swioings">{{item.diesc_name}}</p>
              <p class="switongs">{{item.exposure}}</p>
              <button >自助注册投放</button>

              <router-link :to="{path:`/case`,query:{cast:JSON.stringify(item)}}"  >查看更多案例</router-link>

             </li>
            </ul>
          </div>
       </div>
           </swiper-slide>
         <div class="swiper-pagination" slot="pagination"></div>

         </swiper>
      </div>

     </section>
  </div>
   <div class="swiper-button-prev ss"  slot="button-prev"></div>
   <div class="swiper-button-next sst" slot="button-next"></div>
</div>

<div class="handrs">
  <div class="w">
    <!-- <div class="mebar"></div> -->
    <div class="hands_fiend">
      <img src="../assets/img/firend.png"  ref="handsfriends" alt="">
     <!-- <a href="javascript:;"> 合作伙伴</a> -->

    </div>
     <div class="hands_img">
       <ul>
         <li>
           <img src="../assets/image/wans.png" alt="">
         </li>
          <li>
           <img src="../assets/image/funplus.png" alt="">
         </li>
          <li>
           <img src="../assets/image/le.png" alt="">
         </li>
          <li>
           <img src="../assets/image/shou.png" alt="">
         </li>
          <li>
           <img src="../assets/image/sw.png" alt="">
         </li>
          <li>
           <img src="../assets/image/six.png" alt="">
         </li>
          <li>
           <img src="../assets/image/DeNa.png" alt="">
         </li>
          <li>
           <img src="../assets/image/sy.png" alt="">
         </li>
          <li>
           <img src="../assets/image/you.png" alt="">
         </li>
          <li>
           <img src="../assets/image/lls.png" alt="">
         </li>
          <li>
           <img src="../assets/image/fen.png" alt="">
         </li>
         <li>
           <img src="../assets/image/hulai.png" alt="">
         </li>
          <li>
           <img src="../assets/image/al.png" alt="">
         </li>
          <li>
           <img src="../assets/image/bc.png" alt="">
         </li>
          <li>
           <img src="../assets/image/dy.png" alt="">
         </li>
          <li>
           <img src="../assets/image/ft.png" alt="">
         </li>
          <li>
           <img src="../assets/image/tx.png" alt="">
         </li>
          <li>
           <img src="../assets/image/BANDAI.png" alt="">
         </li>
          <li>
           <img src="../assets/image/netmarble.png" alt="">
         </li>
          <li>
           <img src="../assets/image/lj.png" alt="">
         </li>
          <li>
           <img src="../assets/image/AI.png" alt="">
         </li>
          <li>
           <img src="../assets/img/fle.png" alt="">
         </li>
          <li>
           <img src="../assets/img/fity.png" alt="">
         </li>
          <li>
           <img src="../assets/image/dayc.png" alt="">
         </li>
          <li>
           <img src="../assets/image/zi.png" alt="">
         </li>

       </ul>
      </div>
  </div>
</div>
<div class="footer">
   <div class="w">
     <div class="footer_box">
       <div class="footer-box-header">
·  用心经营  合作顺利 ·
       </div>
       <div class="footer-box-main">
媒体方、广告主、平台三方DMP，超20个维度定向，多标签精准描绘用户画像，同时跨平台排除重复用户，避免重复曝光与成本浪费。 平台自动化标签工具Data Label是通过算法自动打标签和调整标签，缩减标签编程的时间，不断尝试哪些标签对分析应用真正有用
       </div>
       <div class="footer-box-footer">
         <ul>
           <li v-for="(item,index) in mananger" :key="index" >
             <img :src="item.img" alt="">
             <h1>{{item.name}}</h1>
             <p>{{item.desc}}</p>
           </li>

         </ul>
       </div>

     </div>
   </div>
 </div>
<div class="industry">
  <div class="w">
    <!-- <div class="indetrbar"></div> -->
    <div class="indust">
      <!-- <a href="javascript:;" ref="standend">行业资讯</a> -->
      <img src="../assets/img/zixun.png" ref="standend" alt="">
    </div>
    <ul>
      <li v-for="(item,index) in peloobj" :key="index" v-show="item.news_id===42">
        <div class="industr-left" @click="accumulations(peloobj[0].news_id)">
          <img  v-lazy="peloobj[0].news_img" alt="">
         <h2>{{peloobj[0].news_name}}</h2>
         <p>{{peloobj[0].author + '...'}}</p>
         <div class="time">
          <div class="shotime">
             <div class="time-icon">
             <img src="../assets/image/timeg.png" alt="">
           </div>
           <div class="times">{{peloobj[0].add_time}}</div>
           <!-- <div class="timesfut">09:42</div> -->
            <div class="mabr">
              <img src="../assets/image/look.png" alt="">
            </div>
            <div class="ckick">
             {{peloobj[0].show_num}}
            </div>
          </div>

         </div>
        </div>
        <div class="industr-right">
          <ol>

             <li v-for="(item,index) in peloobj" :key="index">
              <div class="inder-masetr">
                <div class="border">
                 <p> {{item.add_time}}</p>
                </div>
                <div class="madebar" @click="$router.push({path:`/new/${item.news_id}`,query:{newst:JSON.stringify(item)}})">
                    <p>{{item.news_name}}</p>
                    <span>{{item.author+'...'}}</span>
                </div>
              </div>
            </li>
            <button @click="more">查看更多 </button>
          </ol>
        </div>
      </li>
    </ul>
  </div>
</div>

<Footer></Footer>

</div>

</div>
</template>

<script>
import img from '../assets/image/about.png'
import img1 from '../assets/image/about3.png'
import img2 from '../assets/image/about2.png'
import img3 from '../assets/image/ico1.png'
import img4 from '../assets/image/ico4.png'
import img5 from '../assets/image/ico3.png'
import img6 from '../assets/image/ico2.png'
import img7 from '../assets/img/banner.png'
import img8 from '../assets/img/banner2.jpg'
import img9 from '../assets/img/banner3.jpg'
import img10 from '../assets/image/feedalck.png'
import img11 from '../assets/image/feedalck2.png'
import img12 from '../assets/image/feedalck3.png'
import img13 from '../assets/image/feedalck4.png'
import img14 from '../assets/img/se.png'
import img15 from '../assets/img/help.png'
import img16 from '../assets/img/top.png'
import img17 from '../assets/img/mr.png'
import img18 from '../assets/img/sg.png'
import img19 from '../assets/img/hx.png'
import img20 from '../assets/img/sw.png'

import img22 from '../assets/img/helpst.png'
import img23 from '../assets/img/serive.png'
import img24 from '../assets/img/tops.png'
// import img25 from '../assets/img/ju.png'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { PeopleOriented, Peoplenews, accumulation } from '../api/index'
import Footer from '../components/Footer'
import Nav from '../components/Nav'

export default {
  components: {
    swiper,
    swiperSlide,
    Footer,
    Nav
  },
  data () {
    const vm = this
    return {
      dialogFormVisible: false,
      shownum: '',
      form: {
        input: '',
        input1: '',
        input2: '',
        textarea: ''
      },
      formLabelWidth: '30px',

      madebarlist: [
        { news_id: 1, time: '13:27', desc: '加入游趣互鱼，携手创梦趁此刻！', text: '"在互联网行业的创业项目中，手游平台吸引了大众关注。游趣互娱的出现，得到了很多玩家和创业者的认可。品牌"...' },
        { news_id: 2, time: ' 09:54', desc: '"《人类跌落梦境》销售破两百万的我看到了社交的重要性"...', text: '"虽然《人类跌落梦境》的定价为12元，在如今的手游付费市场中也算是一款偏贵的游戏，但是却丝毫不影响玩家"...' },
        { news_id: 3, time: '10-29', desc: '"千仞雪化身圣诞特派员 《新斗罗大陆》今日新版本上线"', text: '"《欢乐斗地主》这款“全龄向”游戏走向全民化、娱乐化的亲民路线，以大众的娱乐需求构筑了“合家欢“的沟通"...' },
        { news_id: 4, time: '10-31', desc: '"DNF联合Hello语音跨区助力活动来袭，海量好礼等你赢取"', text: '"DNF联合Hello语音开黑软件推出跨区助力活动，活动时间11月30日至12月26日，在活动期间参与"...' }

      ],

      fiehow: false,
      madeshow: true,
      fiehows: true,
      textbox: false,
      swiperOptions: {
        autoplay: {
          delay: 3000,

          disableOnInteraction: false
        },
        fade: {
          crossFade: true
        },

        loop: true,
        effect: 'cube',
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 100,
          shadowScale: 0.6
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      entrance: [
        {
          id: 1,
          name: '入口一'
        },
        {
          id: 2,
          name: '入口二'
        },
        {
          id: 3,
          name: '入口三'
        }
      ],
      swiperOptions1: {
        autoplay: {
          delay: 3000,

          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          transitionEnd: function () {
            const reaindex = this.realIndex

            vm.handleClickSlide(reaindex)
          }
        },
        loop: true,
        // effect: 'flip',
        // fadeEffect: {
        //   slideShadows: true,
        //   limitRotation: true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      swiperlabel: [
        {
          id: 1,
          img: img17
        },
        {
          id: 2,
          img: img18
        },
        {
          id: 3,
          img: img19
        },
        {
          id: 4,
          img: img20
        }

      ],
      mananger: [
        {
          id: 1,
          img: img11,
          desc: '在线浏览量',
          name: '10万'
        },
        {
          id: 2,
          img: img13,
          desc: '在线咨询',
          name: '255643'
        },
        {
          id: 3,
          img: img12,
          desc: '服务项目',
          name: '2550'
        },
        {
          id: 4,
          img: img10,
          desc: '客户反馈',
          name: '23000'
        }
      ],

      fixedlist: [{ id: 1, img: img14 }, { id: 2, img: img15 }, { id: 3, img: img16 }],
      swiperlist: [
        {
          id: 1,
          img: img7
        },
        {
          id: 2,
          img: img8
        },
        {
          id: 3,
          img: img9
        }
      ],
      crrId: '',
      currsId: '',
      cuytId: '',
      desclist: [
        {
          id: 1,
          name: '《明日方舟》',
          desc: '安装包：1.8G',
          diesc_name: '平均成本：80',
          diesc_type: '游戏类型：二次元',
          exposure: '明日方舟推广，利用二次元优质画质，选择精准人群投放，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级。'

        }

      ],
      requers: [
        { id: 1, img: img3, name: '移动大数据平台', desc: '基于移动大数据，提供信息流广告优选解决方案,多唯定向，精准触达，以实现跨平台数据复用' },
        { id: 2, img: img4, name: '专业运营优化', desc: '独家优化方案及测试体系，专业王盘优化师，标准高效一体化' },
        { id: 3, img: img5, name: '海量需求库', desc: '一对一的客服需求对接，及时充分了解客户需求，并具备专业的商业思维分析及成熟的技术支持' },
        { id: 4, img: img6, name: '高效标准服务', desc: '安全的技术，保证了非人类流量的过滤，媒体环境的定向，LBS跨屏定向可在全国内指定商圈，定向投放' }
      ],
      reagrs: [{ name: '我们是谁', desc: 'Hundred平台隶属于上海致源广告传媒有限公司，基于自主原创动漫和文学。', img: img2 }, { name: '我们做什么', desc: '平台结合了如今市场上游戏投放主流媒体的资源以及我们慢慢挖掘的初步商业化媒体的资源融入平台的SSP。', img: img1 }, { img: img, name: '我们的优势', desc: '拥有王牌优化师，具有标砖高效的流程，三方DMP,跨平台数据，精准投放，获取更有效用户' }],
      list: [{ id: 1, name: '首页' }, { id: 2, name: '关于我们' }, { id: 3, name: '平台优势' }, { id: 4, name: '合作案例' }, { id: 5, name: '合作伙伴' }, { id: 7, name: '行业资讯' }, { id: 8, name: '投放中心' }],
      peloobj: []

    }
  },
  mounted () {
    // console.log(this.$refs.mySwiper.swiper)
    window.addEventListener('scroll', this.mayrefixed, true)
    this.peolnew()
    // this.accumulations()
  },

  methods: {
    async  accumulations (va) {
      // const shonum = sessionStorage.getItem('shownum')
      // console.log(shonum)
      this.$router.push({ path: `/new/${va}`, query: { newst: JSON.stringify(this.peloobj[0]) } })
      const res = await accumulation({

      }, {
        news_id: va
      })
      console.log(res)
      const { data } = res
      if (data.code === 0) {
        this.shownum = data.show_num
      }
    },
    async peolnew () {
      const res = await Peoplenews({

      }, {
        c_id: 1
      })

      const { data } = res
      if (data.code === 0) {
        console.log(data)
        this.peloobj = data.data

        this.peloobj = this.peloobj.splice(0, 4)
      }
    },
    more () {
      this.$router.push({ path: '/more' })
    },
    mousert (item) {
      this.currsId = item.id
      if (item.id === 2) {
        item.img = img22
        this.$refs.mou[1].style.backgroundColor = '#357FEC'
      } else if (item.id === 3) {
        item.img = img24
        this.$refs.mou[2].style.backgroundColor = '#357FEC'
      } else {
        item.img = img23
        this.$refs.mou[0].style.backgroundColor = '#357FEC'
      }
    },
    mouleave (item) {
      if (item.id === 2) {
        item.img = img15
        this.$refs.mou[1].style.backgroundColor = '#fff'
      } else if (item.id === 3) {
        item.img = img16
        this.$refs.mou[2].style.backgroundColor = '#fff'
      } else {
        item.img = img14
        this.$refs.mou[0].style.backgroundColor = '#fff'
      }
      // console.log(this.$refs.mou[1].style.backgroundColor = '#fff')
      // console.log(this.$refs.mou[2].style.backgroundColor = '#fff')
    },

    submit () {
      this.$confirm('您确定要提交此信息吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await PeopleOriented({

        }, {

          cus_partner_name: this.form.input,
          cus_partner_phone: this.form.input1,
          cus_partner_contact: this.form.input2,
          cus_partner_need: this.form.textarea

        })
        console.log(res)
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: '提交成功'
          })
          this.form.input = ''
          this.form.input1 = ''
          this.form.input2 = ''
          this.form.textarea = ''
          this.form.dialogFormVisible = false
        }
        if (res.data.code === 'NOTAP01') {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        } else if (res.data.code === 'NOTAP02') {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        } else if (res.data.code === 'NOTAP03') {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        } else if (res.data.code === 'NOTAP04') {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleClickSlide (index) {
      if (index === 0) {
        this.desclist.forEach((item) => {
          item.name = '《明日方舟》'
          item.desc = '安装包：1.8G'
          item.diesc_name = '平均成本：80'
          item.diesc_type = '游戏类型：二次元'

          item.exposure = '明日方舟推广，利用二次元优质画质，选择精准人群投放，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级。'
        })
      }
      if (index === 1) {
        this.desclist.forEach((item) => {
          item.name = '《三国志战略版》'
          item.desc = '安装包：922.9M  '
          item.diesc_name = '   平均成本：195'

          item.diesc_type = '游戏类型：SLG'
          item.exposure = '三国志战略版，通过第三方人群包数据，进行人群拓展，优选优质人群包投放，多维度，多地域，多人群覆盖，利用优质话题，提高互动。社交裂变 强势曝光！'
        })
      } else if (index === 2) {
        this.desclist.forEach((item) => {
          item.name = '《三国志幻想大陆》'
          item.desc = '安装包：1.4G'
          item.diesc_name = '平均成本：100'
          item.diesc_type = '游戏类型：卡牌'

          item.exposure = ' 三国志幻想大陆推广，有超高的画质，著名声优配音，明星代言，选择精准人群投放，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级。'
        })
      } else if (index === 3) {
        this.desclist.forEach((item) => {
          item.name = '《神武4》'
          item.desc = '安装包：1.2G  '
          item.diesc_name = '平均成本：100 '
          item.diesc_type = '   游戏类型：回合制'
          item.exposure = '神武4 游戏推广，加大转化线上超优惠活动引流，根据游戏特点多帮派等进行多维度多人群包选择投放，多维度覆盖人群，扩大曝光层次。'
        })
      } else if (index === 4) {
        // this.desclist.forEach((item) => {
        //   item.exposure = '官场风云推广，提升用户信任度，加大转化线上超优惠活动引流，戳中用户消费痛点细分人群，多维度覆盖，扩大曝光层级'
        // })
      }
    },
    entrence (item) {
      this.cuytId = item.id
    },
    enrtbsty (item) {
      const { id } = item
      if (id === 1) {
        window.location.href = 'http://login.hundredzy.com/pages/signin'
      } else if (id === 2) {
        window.location.href = 'http://login.hundredzy.com/pages/signin'
      } else {
        window.location.href = 'http://login.hundredzy.com/pages/signin'
      }
    },
    fdsg () {
      this.textbox = false
    },
    mdusf (item) {
      if (item.id === 7) {
        this.textbox = false
      }
      if (item.id === 8) {
        this.textbox = true
      }
    },
    mashow (item) {
      if (item.id !== 8) {
        this.textbox = false
      }
    },

    enters () {
      this.$refs.swipe.swiper.autoplay.stop()
    },
    leavese () {
      this.$refs.swipe.swiper.autoplay.start()
    },

    mainjquers (item) {
      this.crrId = item.id
    },
    logo () {
      location.reload()
    },
    mayrefixed () {
      const top = document.body.scrollTop || document.documentElement.scrollTop// 兼容写法
      if (top > 740) {
        this.fiehow = true
      } else {
        this.fiehow = false
      }
    },

    fixed (item) {
      this.currsId = item.id
      if (item.id === 3) {
        let top = document.documentElement.scrollTop || document.body.scrollTop
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 50
          if (top <= 0) {
            clearInterval(timeTop)
          }
        }, 10)
      }
      if (item.id === 1) {
        this.dialogFormVisible = true
      }
    },
    leave () {
      this.$refs.mySwiper.swiper.autoplay.start()
    },
    enter () {
      this.$refs.mySwiper.swiper.autoplay.stop()
    },
    fn () {
      this.$refs.mySwiper.swiper.autoplay.start()
    },
    maquer (item) {
      if (item.id === 2) {
        this.$refs.mainshe.scrollIntoView(true)
      } else if (item.id === 3) {
        this.$refs.mdidest.scrollIntoView(true)
      } else if (item.id === 4) {
        this.$refs.hovsert.scrollIntoView(true)
      } else if (item.id === 5) {
        this.$refs.handsfriends.scrollIntoView(true)
      } else if (item.id === 6) {
        this.$refs.meidhoes.scrollIntoView(true)
      } else if (item.id === 7) {
        this.$refs.standend.scrollIntoView(true)
      } else if (item.id === 8) {

      } else {
        location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  .back {
.my-enter,.my-leave-to{
        opacity: 0;
        transform: translateX(80px);
    }

    .my-enter-active,.my-leave-active{

        transition: all 0.5S ease
    }
    .wswiper {

    .swper_box {
        position: relative;

        .swiper_mouser {
          position: absolute;
          top: 725px;
          left: 720px;
          z-index: 88;
          img {
            width: 44px;
            height: 69px;
          }
        }
        .swipertmodie {
          position: absolute;
          top: 520px;
          left:675px;
          z-index: 66;
          width: 140px;
          height: 45px;
          border: 2px solid #FFFFFF;
          box-shadow: 0px 6px 10px 0px rgba(34, 117, 177, 0.53);
          border-radius: 36px;
          a {
            display: block;
            text-align: center;
            line-height: 40px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fff;
            opacity: 0.99;

          }
        }
        .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
          left: -17px;
        }
        .swiper-button-prev {
          background: url(../assets/image/left.png) no-repeat;
          background-size: 100% 100%;
          left: 170px;
          //自定义边框
          outline: none !important;

        }
        .swiper-button-next {
           background: url(../assets/image/right.png) no-repeat;
          background-size: 100% 100%;
          right: 170px;
          outline: none !important;
        }

      img {
        cursor: pointer;
        height: 854px;
      }
    }
    }
    .fixed {

      position: fixed;

      top: 90px;
      right: 17px;
      z-index: 333333;
       .fixd {
          background-color: #1BABFC;
        }
      li {

    width:90px;
    // height: 172px;
    text-align: center;
    line-height: 101px;
    cursor: pointer;
    background-color: #fff;
    &:nth-child(1) {
      border-radius: 10px 0 0 0 ;
    }
      &:last-child {
      border-radius: 0 0 0 10px ;
    }
     &:nth-child(2) img {
         width: 54px;
         height: 54px;
      }
        &:nth-child(3) img {
         width: 55px;
      height: 55px;
      }
    img {
      width: 54px;
      height: 50px;
      display: inline-block;
      margin-top: 62px;
    }
     }
    }
    .w {
      main {
        position: relative;
        height: 778px;
        // .cus {
        //   width: 100%;
        //   border-bottom: 1px solid#EBECED;
        //  position: absolute;
        //  top: 60px;
        // }
        margin-top: 100px;
         span {
          display: block;
          text-align: center;
        }
        .main_header {
        cursor: pointer;
        text-align: center;

        height: 28px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;

        margin-bottom: 66px;
        a {
          color: #3F3F40;
          &:hover {
            border-bottom: 5px solid #046AFF;

          }
        }

        }
        .main {
          text-align: center;
        height: 208px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #323333;
        line-height: 32px;
        }
        .main_footer {

          text-align: center ;
          margin-top: 33px;
          ul {
            display: flex;
            li {
              margin-right: 25px;

              img {

                width: 375px;
                height: 240px;
               transition: 1s ease-in-out;
               -webkit-transform-style: preserve-3d;
                transform-style: preserve-3d;
               &:hover {
               -webkit-transform: rotateY(0.5turn);
               transform: rotateY(0.5turn);
                opacity: 0.6;

               }
              }

              span {

                width: 90px;
                height: 21px;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #323333;
                line-height: 32px;
                margin-left: 110px;
               margin: 20px auto
              }
              p {
                margin-top: 20px;
                width: 341px;
                height: 42px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #656566;
                line-height: 26px;
                  margin: 0px auto
              }
            }
          }
        }
      }
    }
    .mased {
      // background-color: #fff;
       background: url(../assets/image/ma.png) no-repeat ;
      // background: url(../assets/image/one.png) no-repeat ;
      background-position: 0 415px;
  .w {
      .juqerbar {
           margin-top: 55px;
        .number {
          position: relative;
          ul {
              display: flex;
            li {
              &:nth-child(2) img {
                width: 60px;
                height: 83px;
                  position: absolute;

                left: 423px;
              }
               &:nth-child(3) img {
                width: 62px;
                height: 84px;
                  position: absolute;

                left: 730px;
              }
               &:nth-child(4) img {
                width: 66px;
                height: 81px;
                  position: absolute;

                left: 1030px;
              }
              img {
                width: 44px;
                height: 81px;
                display: inline-block;
                position: absolute;
                top: 70px;
                left:110px;

              }
            }
          }
        }

          .main_jquers_header {
            width: 121px;
            height: 87px;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            cursor: pointer;
            line-height: 19px;
            margin: 0 515px;
           text-align: center;
           img {
             width: 179px;
             height: 87px;
           }
           a {
             color: #333333;
             &:hover {
               border-bottom: 5px solid #046AFF;
             }
           }
     }
     .Plat {
       text-align: center;

     }
     .main_jquers_main {
       position: relative;
        height: 430px;
       .mainst {
         background-color: #357FEC;
         color: #fff ;

       }
       margin-top: 150px;

       ul {
         display: flex;
         li {

           cursor: pointer;
           width: 277px;
           height: 370px;
           background: #FFFFFF;
           box-shadow: 0px 4px 12px 1px rgba(159, 189, 219, 0.3);
           border-radius: 12px;
           margin-right: 30px;

  .post {
          width: 90px;
          height: 90px;
         background-color: #fff;
          margin:40px 109px 48px 95px ;
          border-radius: 50%;
            img {
             width: 57px;
             height: 55px;
             display: inline-block;
             margin-top: 19px;
             margin-left: 15px;
           }
       }
           p {
             width: 159px;
             height: 21px;
             font-size: 20px;
             font-family: Microsoft YaHei;
             font-weight: bold;
             line-height: 32px;
              text-align: center;
             margin: 24px auto;
           }
           span {
             display: block;
             width: 179px;
              height: 108px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;

              line-height: 23px;
              margin: 0 auto;
           }
         }
       }

     }
     .main_jquers_footer {
       text-align: center;
     }
      }
    }
    }

   .alge {
      .ss {
     left: 50px;
      }
      .sst {
        right: 150px;
         outline: none !important;
      }
      .w {
        section {
          .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
            left: 90px;
            width: 100%;
            top: 671px;
            height: 30px;
          }

          // .maretbar {
          //   width: 100%;
          //   border-bottom: 1px solid #EBECED;
          //   position: absolute;
          //   top: 90px;
          // }
          position: relative;
          margin-top: 100px;
            .panter {
            width: 125px;
            height: 29px;
            font-size: 28px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 50px;

            img {
              width: 1200px;
              height: 63px;
            }
            a {
            color: #3F3F40;
            &:hover {
              border-bottom: 5px solid #046AFF;
            }
            }

            }
            .swper_main {
              display: flex;
              margin-top: 114px;
              .swiper-container {
                width: 600px;
                cursor: pointer;
              }
              img {
                width: 627px;
                cursor: pointer;
              }
              .swper_right {
                margin-left: 20px;
                ul {
                  li {
                    margin-top: 110px;
                     .desc {
                width:150px;
                height: 20px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
                line-height: 19px;
                margin-bottom: 40px;
                margin-top: 20px;
              }
              .swiping {
                width: 164px;
                height: 18px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 19px;
              }
              .swioings {
                width: 362px;
              height: 45px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 26px;
              margin-top: 41px;
              }
              .switongs {
                width: 359px;
                height: 43px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 26px;
                margin-top: 41px;
              }
              button {
                margin-top: 86px;
                width: 204px;
                height: 56px;
                background: linear-gradient(-4deg, rgba(0, 93, 255, 0.84), rgba(4, 190, 253, 0.84));
                box-shadow: 0px 5px 17px 1px rgba(62, 116, 147, 0.35);
                border-radius: 4px;
                color: #fff;
                cursor: pointer;
              }
              .radius {
                margin-top: 71px;
              }
              a {
                display: block;
                width: 124px;
                height: 16px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #0696FE;
                line-height: 26px;
                margin-top:120px;
                cursor: pointer;
              }
                  }
                }

              }
            }
            .fotoe {
              position: absolute;
             width: 100%;
             top: 748px;
             left: 46px;
              height: 440px;
              background-color: pink;
              z-index: 33;
            }
        }
    }
   }

   .footer {
     width: 100%;
     position: absolute;
    //  top: 3347px;
   background: url(../assets/image/city.png) no-repeat;
   background-size: 100% 100%;
   margin-top: -80px;
  //  bottom: 1450px;
   z-index: 99;
     .w {
       .footer_box {
       height: 440px;
       .footer-box-header {
         width: 319px;
         height: 29px;
         font-size: 28px;
         font-family: Microsoft YaHei;
         font-weight: bold;
         color: #FFFFFF;
         line-height: 19px;
         margin:  0 auto;
         text-align: center;
         margin-top: 100px;
         letter-spacing: 3px;
       }
       .footer-box-main {
          height: 53px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 37px;
          margin:  60px auto;
         text-align: center;
       }
       .footer-box-footer {
         margin: 52px auto;
        //  text-align: center;
         ul {
           display: flex;
          margin-left: 110px;
           li {
             margin-right: 157px;
             &:nth-child(2) {
                 img {
                  margin-left: 40px;
             }
             }
               &:nth-child(1) {
                 img {
                   width: 70px;
                   height: 48px;
                   margin-top: 15px;
             }
             }
            img {
           width: 64px;
           height: 63px;
           margin-left: 20px;

             }
             h1 {
            height: 53px;
            font-size: 38px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #F7F8FB;
            line-height: 25px;
            margin-top:  46px;
            text-align: center;
             }
             p {

          height: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #F7F8FB;
          line-height: 25px;
          font-size: 20px;
          text-align: center;
             }
           }
         }

       }
     }
     }

   }
   .handrs {
     background: url(../assets/img/ju.png) no-repeat;
     background-size: 100% 100%;
     position: relative;
         z-index: 33;
    top: -202px;
     .mebar {
     border-bottom: 1px solid #EBECED;
     position: absolute;
     top: 88px;
     width: 1200px;

     }

     .w {

       .hands_fiend {
         cursor: pointer;
         width: 126px;
        height: 29px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 88px;
        padding-top: 75px;
        img {
          width: 1200px;
          height: 63px;
        }
        a {

        color: #3F3F40;
        text-align: center;
        // margin-left: 460px;
        &:hover {
          border-bottom: 5px solid #046AFF;
        }
        }
       }
       .hands_img {
         margin-top: 113px;
         ul {
           width: 1160px;
           overflow: hidden;
           li {
            float: left;
             width: 230px;
               height: 105px;
                  border-right: 1px solid  #E6E6E6;
                border-bottom: 1px solid  #E6E6E6;
                padding-left: 12px;
                padding-top: 10px;

                 img {
                 width: 182px;
               height: 66px;
               cursor: pointer;
                  transition:all 1s;
               -webkit-transition:all 1s;
               -o-transition:all 1s;

                  &:hover {
                     box-sizing: border-box;
                    opacity: 1;
                   transform:scale(0.5,0.5);
                 -webkit-transform:scale(0.5,0.5);
                 -o-transform:scale(0.5,0.5);
                  }
             }
                &:nth-child(2) {
              padding-left: 12px;
              padding-top: 10px;
                  img {
                    width: 203px;
                    height: 50px;
                  }
                }
                   &:nth-child(3) {
                 padding-top: 10px;
              padding-left: 24px;
               img {
                    width: 158px;
                    height: 65px;
                  }
                }
                     &:nth-child(4) {
                      padding-top: 10px;
                        img {
                    width: 123px;
                    height: 65px;
                  }
              padding-left: 44px;
                }
                     &:nth-child(5) {
                         padding-top: 10px;
                      img {
                    width: 208px;
                    height: 62px;
                  }

                       border-right: 0;
                      padding-left: 12px;
                }

                  &:nth-child(6) {
                      img {
                    width: 179px;
                    height: 71px;
                  }
                padding-top: 18px;
                }
                   &:nth-child(7) {
                      img {
                    width: 203px;
                    height: 65px;
                  }
                  padding-top: 23px;
                }
                 &:nth-child(8) {
                      img {
                    width: 172px;
                    height: 67px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;
                }
                  &:nth-child(9) {
                      img {
                    width: 204px;
                    height: 67px;
                  }
                  padding-left: 15px;
                   padding-top: 23px;
                }
                  &:nth-child(10) {
                      img {
                    width: 206px;
                    height: 61px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;
                  border-right: 0;
                }
                 &:nth-child(11) {
                      img {
                    width: 181px;
                    height: 57px;
                  }
                  padding-left: 22px;
                  padding-top: 23px;

                }
                 &:nth-child(12) {
                   img {
                    width:206px;
                    height: 52px;
                  }
                  padding-left: 12px;
                  padding-top: 23px;

                }
                 &:nth-child(13) {
                   img {
                    width:171px;
                    height: 45px;
                  }
                  padding-left: 22px;
                   padding-top: 26px;

                }
                 &:nth-child(14) {
                   img {
                    width:184px;
                    height: 57px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;

                }
                 &:nth-child(15) {
                   img {
                    width:204px;
                    height: 53px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;
                  border-right: 0;
                }
                 &:nth-child(16) {
                   img {
                    width:176px;
                    height: 63px;
                  }
                  padding-left: 22px;
                   padding-top: 23px;

                }
                 &:nth-child(17) {
                   img {
                    width:206px;
                    height: 59px;
                  }
                  padding-left: 15px;
                  padding-top: 23px;

                }
                 &:nth-child(18) {
                   img {
                    width:81px;
                    height: 88px;
                  }
                  padding-left: 68px;
                  padding-top: 10px;

                }
                 &:nth-child(19) {
                   img {
                    width:88px;
                    height: 89px;
                  }
                  padding-left: 68px;
                  padding-top: 10px;

                }
                 &:nth-child(20) {
                   img {
                    width:172px;
                    height: 98px;
                  }
                  padding-left: 35px;
                  padding-top: 6px;
                   border-right: 0;
                }
                 &:nth-child(21) {
                   img {
                    width:179px;
                    height: 73px;
                  }
                  padding-left: 28px;
                  padding-top: 12px;

                }
                 &:nth-child(22) {
                   img {
                    width:178px;
                    height: 72px;
                  }
                  padding-left: 28px;
                  padding-top: 12px;

                }
                 &:nth-child(23) {
                   img {
                    width:205px;
                    height: 44px;
                  }
                  padding-left: 11px;
                  padding-top: 25px;

                }
                 &:nth-child(24) {
                   img {
                    width:138px;
                    height: 86px;
                  }
                  padding-left: 32px;
                  padding-top: 12px;

                }
                 &:nth-child(25) {
                   img {
                    width:138px;
                    height: 86px;
                  }
                  padding-left: 40px;
                  padding-top: 12px;
                  border-right: 0;

                }

           }
         }
       }
     }
   }
  //  .contact {
  //    height: 800px;
  //    background: url(../assets/image/hzd.png) no-repeat;
  //    background-size: 100% 100%;
  //    margin-top: 85px;
  //     .w {
  //       padding-top: 80px;
  //       .panters {
  //         // margin-top: 80px;
  //         text-align: center;
  //         height: 87px;
  //         font-size: 28px;
  //         font-family: Microsoft YaHei;
  //         font-weight: bold;
  //         color: #FFFFFF;
  //         line-height: 19px;
  //         cursor: pointer;
  //         img {
  //           display: inline-block;
  //           width: 173px;
  //           height: 87px;
  //            margin:  0 auto;
  //            margin-bottom: 80px;
  //         }
  //         a {
  //             color: #FFFFFF;
  //           &:hover {
  //               border-bottom: 4px solid  #FFFFFF;
  //           }
  //         }

  //       }
  //        p {
  //           margin-top: 30px;
  //           height: 20px;
  //           font-size: 18px;
  //           font-family: Microsoft YaHei;
  //           font-weight: 400;
  //           color: #FFFFFF;
  //           line-height: 19px;
  //           text-align: center;
  //         }
  //         ul {
  //           margin-top: 70px;
  //           li {
  //             display: flex;
  //             .inputs {
  //               width: 512px;
  //               .el-input {
  //               width: 512px;
  //               border-radius: 4px;
  //               margin-bottom: 60px;
  //               ::v-deep.el-input__inner {
  //               width: 512px;
  //               height: 54px;
  //               background-color: transparent !important;
  //               color: #fff;
  //               }
  //                }
  //               }

  //             .textarea {
  //               width: 568px;
  //               margin-left: 120px;
  //               .textar {
  //                ::v-deep .el-textarea__inner {
  //                  width: 568px;
  //                   height: 285px;
  //                   background-color: transparent !important;
  //                   color: #fff;
  //                 }
  //               }
  //             }

  //           }
  //            button {
  //               display: block;
  //               width: 410px;
  //               height: 64px;
  //               background: #1BABFC;
  //               border-radius: 8px;
  //               margin:  0 auto;
  //               cursor: pointer;
  //               a {
  //               height: 20px;
  //               font-size: 20px;
  //               font-family: Microsoft YaHei;
  //               font-weight: 400;
  //               color: #FFFFFF;
  //               line-height: 19px;
  //               }
  //             }
  //         }
  //     }
  //  }
   .industry {
     margin-top: 565px;
     position: relative;
     .indetrbar {
       position: absolute;
       top: 102px;
       width: 1200px;
       border-bottom: 1px solid #EBECED;
     }
     .w {
       .indust {
        height: 29px;
        font-size: 29px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        cursor: pointer;
        line-height: 90px;
        text-align: center;
        margin-bottom: 160px;
        margin-top: 60px;
        a {
           color: #3F3F40;
           &:hover {
              border-bottom: 4px solid#046AFF;
           }
        }
       }
      ul {
        li {
          display: flex;
          .industr-left {
            cursor: pointer;
            margin-right: 50px;
            img {
              width: 540px;
              height: 372px;
            }
            h2 {
            height: 22px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #1777FE;
            line-height: 20px;
            margin-top: 33px;

            margin-bottom: 24px;
            }
            p {
              width: 529px;
              height: 68px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 28px;
              margin-bottom: 20px;
            }
            .time {
              .shotime {
                display: flex;
                 .time-icon {
                img {
                  width: 21px;
                  height: 21px;
                }

                  }

                    .times {
                  margin-left: 13px;
                }
                .timesfut {
                  margin-left: 13px;
                }
                .mabr {
                  margin-left: 50px;
                  img {
                    width: 28px;
                    height: 18px;
                  }
                }
                .ckick {
                  margin-left: 12px;
                }
              }

            }
          }
           .industr-right {
                   display: flex;

             ol {
               li {
                 margin-bottom: 31px;

                    &:nth-child(1) .inder-masetr .border{
                   width: 167px;
                   margin-top: 2px;
                   }
                    &:nth-child(2) .inder-masetr .border{
                  width: 167px;
                     margin-top: 2px;
                   }
                    &:nth-child(1) .inder-masetr a{

                   font-weight: 700;
                   }
                    &:nth-child(1) .inder-masetr a{
                  margin-left: 20px !important;
                   font-weight: 700;
                   }
                  &:nth-child(2) .inder-masetr a{
                  margin-left: 57px !important;
                   font-weight: 700;
                   }
                     &:nth-child(3) .inder-masetr a{
                     margin-left: 30px !important;
                      font-weight: 700;
                   }
                      &:nth-child(4) .inder-masetr a{
                     margin-left: 55px !important;
                     font-weight: 700;
                   }
                    &:nth-child(3) .inder-masetr .border{
                   width: 167px;
                      margin-top: 2px;
                   }
                    &:nth-child(4) .inder-masetr .border{
                   width: 145px;
                      margin-top: 2px;
                   }
                 .inder-masetr{
                   display: flex;

                   .border {
                     width: 100px;
                     height: 28px;
                    background: #CCCCCC;
                    border-radius: 4px;
                     margin-right: 40px;
                     text-align: center;
                     line-height: 28px;
                     p {

                      height: 14px;
                      font-size: 16px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #FFFFFF;
                      line-height: 28px;
                     }
                   }

                   .madebar {
                     cursor: pointer;
                     p {
                      //  width: 360px;
                       margin-bottom: 16px;
                      //  height: 21px;
                       font-size: 20px;
                       font-family: Microsoft YaHei;
                       font-weight: 400;
                       color: #404040;
                      //  line-height: 23px;

                     }
                     span {
                      font-size: 16px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #999999;
                      line-height: 25px;
                      letter-spacing: 1px;
                     }
                      a {
                        color: #357FEC;
                      }
                   }
                 }
               }
               button {
                 width: 144px;
                 height: 51px;
                 border: 1px solid #0696FE;
                 border-radius: 4px;
                 background-color: #fff;
                 color:#0696FE ;
                 cursor: pointer;
                 margin-left: 480px;
               }
             }
          }
        }
      }
     }
   }
  .daylog {
      // height: 612px;
     ::v-deep.el-dialog__body {
      padding: 20px 20px;

    }
   .el-input {
     margin-bottom: 25px;
     font-size: 13px;
     font-weight: 400;
   }
   ::v-deep.el-textarea__inner {
     height: 200px;
   }
    ::v-deep.el-dialog__footer {
   padding: 9px 208px 5px !important;
 .el-button  {
     width: 340px;
     height: 45px;
    //  margin-right: 190px;
     margin-bottom: 20px;

   }
   }

  }
  }
}

</style>
